import { useState, useEffect } from "react";

interface Props {
  value: any;
  delay: number;
}

function cloneValue<T extends Record<string, any>>(value: T): T {
  if (value === null || typeof value !== "object") {
    return value;
  }

  if (Array.isArray(value)) {
    return [...value] as unknown as T;
  }

  const clonedObj: Partial<T> = { ...value };

  return clonedObj as T;
}

export const useDebounce = ({ value, delay }: Props) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(cloneValue(value));
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};
